import { useRef, useState } from "react";
import Autocomplete from "react-google-autocomplete";
import toast from "react-hot-toast";
import Styles from "./LocationInput.module.css";
import { MapAPIKey } from "../../Utility/Utility";

export default function LocationInput({
  errorText,
  onSelectAddress,
  defaultAddress = "",
}) {
  const inputRef = useRef(null);
  const [loadingLocation, setLoadingLocation] = useState(false);

  const getAddressFromLatLng = async (lat, lng) => {
    try {
      if (!window.google) {
        throw new Error("Google Maps not loaded");
      }

      const geocoder = new window.google.maps.Geocoder();

      return new Promise((resolve, reject) => {
        geocoder.geocode(
          { location: { lat: Number(lat), lng: Number(lng) } },
          (results, status) => {
            if (status === "OK" && results.length > 0) {
              resolve(results[0].formatted_address);
            } else {
              reject(`Geocoder failed due to: ${status}`);
            }
          },
        );
      });
    } catch (error) {
      console.error("Reverse geocoding error:", error);
      throw error;
    }
  };

  const getCurrentLocation = () => {
    return new Promise((resolve, reject) => {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          resolve({
            lat: position.coords.latitude,
            lng: position.coords.longitude,
          });
        },
        (error) => {
          toast(error.message, { type: "error" });
        },
      );
    });
  };

  const handleCurrentLocation = () => {
    setLoadingLocation(true);
    getCurrentLocation()
      .then((position) => {
        getAddressFromLatLng(position.lat, position.lng)
          .then((address) => {
            if (inputRef.current) {
              inputRef.current.value = address;
            }
            onSelectAddress({
              address,
              ...position,
              // source: "current_location",
            });
          })
          .catch((e) => {
            toast(e.message, { type: "error" });
          })
          .finally(() => {
            setLoadingLocation(false);
          });
      })
      .finally(() => {
        setLoadingLocation(false);
      });
  };

  return (
    <div className={Styles.mainContainer}>
      <label className="label">
        Delivery Location <span className="text-danger fs-5">*</span>
      </label>

      <div className={Styles.inputWrapper}>
        <Autocomplete
          apiKey={MapAPIKey}
          ref={inputRef}
          defaultValue={defaultAddress}
          placeholder="Select or type address..."
          className={Styles.googleInput}
          options={{
            types: ["geocode", "establishment"],
            componentRestrictions: { country: "in" },
          }}
          onPlaceSelected={(place) => {
            onSelectAddress({
              address: place.formatted_address,
              lat: place.geometry.location.lat(),
              lng: place.geometry.location.lng(),
            });
          }}
        />

        <button
          type="button"
          className={Styles.locationBtn}
          onClick={handleCurrentLocation}
          disabled={loadingLocation}
          title="Use current location"
        >
          {loadingLocation ? "⏳" : "📍"}
        </button>
      </div>

      {errorText && (
        <div className={`${Styles.locationErrorMsg} text-danger`}>
          {errorText}
        </div>
      )}
    </div>
  );
}
